/**
 * Route paths for the purchase orders module.
 * Single source of truth — reuse these instead of hard-coding `/purchase-orders...` strings.
 */
export const PURCHASE_ORDERS_ROUTES = {
  root: "/purchase-orders",
  create: "/purchase-orders/create",
} as const;

export const purchaseItemcolumnHeaders = [
  { field: "name", headerName: "Name", flex: 2 },
  { field: "quantity", headerName: "Quantity", flex: 1 },
  { field: "price", headerName: "Price", flex: 1 },
  { field: "total", headerName: "Total", flex: 1 },
];

export const purchaseOrderColumnHeaders = [
  { field: "sl", headerName: "Sl No", flex: 0.75 },
  { field: "orderNo", headerName: "Order No", flex: 1 },
  { field: "orderDate", headerName: "Order Date", flex: 1.5 },
  { field: "requiredDate", headerName: "Required Date", flex: 1.5 },
  { field: "vendorName", headerName: "Vendor", flex: 2 },
  { field: "assigneeName", headerName: "Assignee", flex: 2 },
  { field: "totalAmount", headerName: "Total Amount", flex: 1.5 },
];
